











import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ContinuarButton extends Vue {
  handleClick() {
    this.$emit('click');
  }
}
